/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Proxy_RotationInputs */

const en_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy rotation`)
};

const ar_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدوير البروكسي`)
};

const bn_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রক্সি রোটেশন`)
};

const de_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy-Rotation`)
};

const es_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotación de proxy`)
};

const fr_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotation des procurations`)
};

const pt_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotação de proxy`)
};

const zh_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理轮换`)
};

const tr_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vekil rotasyonu`)
};

const ru_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ротация прокси`)
};

const pl_svchip_proxy_rotation = /** @type {(inputs: Svchip_Proxy_RotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotacja serwerów proxy`)
};

/**
* | output |
* | --- |
* | "Proxy rotation" |
*
* @param {Svchip_Proxy_RotationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_proxy_rotation = /** @type {((inputs?: Svchip_Proxy_RotationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Proxy_RotationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_proxy_rotation(inputs)
	if (locale === "bn") return bn_svchip_proxy_rotation(inputs)
	if (locale === "de") return de_svchip_proxy_rotation(inputs)
	if (locale === "es") return es_svchip_proxy_rotation(inputs)
	if (locale === "fr") return fr_svchip_proxy_rotation(inputs)
	if (locale === "pt") return pt_svchip_proxy_rotation(inputs)
	if (locale === "zh") return zh_svchip_proxy_rotation(inputs)
	if (locale === "tr") return tr_svchip_proxy_rotation(inputs)
	if (locale === "ru") return ru_svchip_proxy_rotation(inputs)
	if (locale === "pl") return pl_svchip_proxy_rotation(inputs)
	return en_svchip_proxy_rotation(inputs)
});